/**
 * Module that just exports window.setInterval to make it easier to mock and test
 */

export default setInterval;
